export const tableOption = function () {
    return {
        add: '新增',
        edit: '修改',
        view: '查看',
        page: true,
        selection: false,
        index: false,
        indexLabel: '序号',
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewFormSlot: true,
        labelSuffix: '：',
        align: 'left',
        size: 'small',
        maxHeight: '100%',
        labelWidth: '100px',
        labelPosition: 'right',
        menuWidth: 200,
        menuAlign: "center",
        searchMenuSpan: 6,
        searchBtn: false,
        dialogHeight: 350,
        dialogWidth: '640px',
        emptyText: '暂无数据',
        menu: false,
        column: [{
            label: '回路名称',
            prop: 'deviceName',
            search: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            editDisabled: false,
            overHidden: true,
            align: 'center',
        },
            {
                label: '起始数值（kW·h）',
                prop: 'startValue',
                search: false,
                searchSlot: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center'
            },
            {
                label: '截止数值（kW·h）',
                prop: 'endValue',
                searchSlot: false,
                search: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
            },
            {
                label: '差值（kW·h）',
                prop: 'energyMeterData',
                search: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center'
            }
        ]
    }
}
